import { Reducer } from 'redux'
import Cookies from 'universal-cookie'
import * as actions from './actions'
import { getAccessToken, setAccessToken } from '../../utils/token'

export const cookies = new Cookies()

export type SessionState = Readonly<{
  accessToken: string | null
  refreshToken: string | null
}>

export const initState: SessionState = {
  accessToken: null,
  refreshToken: null
}

// reducer
export const sessionReducer: Reducer<SessionState, actions.SessionActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.SET: {
      const { accessToken, refreshToken } = action.payload.session
      // localStorage.setItem('id', id)
      // localStorage.setItem('uid', userId)

      return {
        ...state,
        accessToken,
        refreshToken
      }
    }

    case actions.RESTORE: {
      const refreshToken = localStorage.getItem('refresh_token')
      const accessToken = getAccessToken()

      return {
        ...state,
        accessToken,
        refreshToken
      }
    }

    case actions.CLEAR: {
      // console.log('clearing session')
      localStorage.clear()
      setAccessToken('')
      return initState
    }
    default:
      return state
  }
}
